import { Segment } from "@/types/types.ts"
import * as React from "react";
import { ContextMenuTypes } from "@/enum/contextMenuTypes.ts";
import clsx from "clsx";
import styles from "@/features/AudioWorkstation/components/AudioEditorTabs/DetailsPane.module.scss";
import { FlexBox } from "@/common/components/Box/FlexBox.tsx";
import useCurrentContextMenu from "@/common/hooks/useCurrentContextMenu.ts";
import {
  SegmentTableRowPlayerProgress
} from "@/features/AudioWorkstation/components/AudioEditorTabs/EditorTabPane/SegmentTableRowPlayerProgress.tsx";

type Props = {
  segment: Segment
}

export const SegmentTableRowPlayer = (props: Props) => {
  const [, setCurrentContextMenu] = useCurrentContextMenu()
  const {
    segment,
  } = props

  return (
    <FlexBox
      sx={{
        overflow: 'hidden',
        width: '100%',
        minWidth: '100%',
        flexDirection: "row",
        height: '30px',
        wrap: "nowrap",
        alignItems: "center",
        "& > .children": {
          // mr: 2,
          fontSize: "90%",
          opacity: .7,
        },
      }}
      onContextMenu={(mouseEvent) =>
        setCurrentContextMenu({
          type: ContextMenuTypes.TABLE_ROW_SEGMENT,
          data: {
            segment,
            mouseEvent,
          },
        })
      }
      className={clsx({
        [`segment-row-${segment.id}`]: true,
        [styles.SegmentRow]: true,
      })}
      key={`segment-player-${segment.id}`}
    >
      <SegmentTableRowPlayerProgress segment={segment} />
    </FlexBox>
  )
}
